import { gql } from "@apollo/client";

// The payments list carries the same columns as the invoice ledger
// (reports/upi-invoice-ledger.xlsx), because accounting reads both for the same
// purpose. The money split (topUpAmount / backendCharges / amount) is derived
// server-side by one shared implementation so the two cannot disagree.
export const GET_ALL_PAYMENTS = gql`
  query GetAllPayments($limit: Int, $offset: Int, $searchTerm: String, $fromDate: String, $toDate: String) {
    getAllPayments(limit: $limit, offset: $offset, searchTerm: $searchTerm, fromDate: $fromDate, toDate: $toDate) {
      success
      count
      error
      data {
        transactionId
        bankAlertRef
        date
        billingName
        customerName
    topUpAmount,             
    backendCharges,      
        topUpAmountGst,
    backendChargesGst,
        pdCaseCharge
        amount
        months
        kycMode
        vin
        billingAddressWithPincode
        pincode
        gstDetails
        emailId
        panDetails
        contactNumber
        chequeRefNo
        remitterName
        dealerName
        dealerCode
        billTo
        monthsPaidFor
        chargeBasis
        rtoState
        vehicleModel
        imei
        iccid
        sessionId
        source
        paymentReceived
        isTestPayment
        missingForInvoice
        invoiceStatus
        invoiceNumber
        invoiceError
      }
    }
  }
`;

// Sessions still waiting for money. Deliberately a separate query and a
// separate tab: they are not payments, and mixing them into the money list
// meant 104 rows showing Rs 0.
export const GET_PENDING_PAYMENTS = gql`
  query GetPendingPayments($limit: Int, $offset: Int, $searchTerm: String, $fromDate: String, $toDate: String) {
    getPendingPayments(limit: $limit, offset: $offset, searchTerm: $searchTerm, fromDate: $fromDate, toDate: $toDate) {
      success
      count
      error
      data {
        sessionId
        date
        source
        kycMode
        months
        status
        customerName
        billingName
        contactNumber
        vin
        imei
        vehicleModel
        dealerName
        dealerCode
        rtoState
        expectedAmount
      }
    }
  }
`;
